
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "077706ab6e4e3540c7af87ecc557b2e29ad95c5b",
  "nuxt": {
    "buildId": "07451ba8-530b-4144-9e08-c274bf7dbee0"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
